import { render, staticRenderFns } from "./StoreUpdateSegment.vue?vue&type=template&id=6c207d0b&"
import script from "./StoreUpdateSegment.vue?vue&type=script&lang=js&"
export * from "./StoreUpdateSegment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports